<template>
  <Content v-if="!loading" class="layout-content">
    <!-- 数据列表渲染区域 -->
    <Row>
      <Col span="12">
        <Card style="margin:20px;">
          <template #title>
            <Icon type="ios-stats"></Icon>
              文章统计
          </template>
          <Row>
            <Col span="4">
              文章
            </Col>
            <Col span="4">
              <NumberInfo sub-title="1小时新增" :total="this.article_data.hour_count"  />
            </Col>
            <Col span="4">
              <NumberInfo sub-title="1天新增" :total="this.article_data.day_count"  />
            </Col>
            <Col span="4">
              <NumberInfo sub-title="7天新增" :total="this.article_data.week_count"  />
            </Col>
            <Col span="4">
              <NumberInfo sub-title="30天新增" :total="this.article_data.month_count"  />
            </Col>
            <Col span="4">
              <NumberInfo sub-title="总数" :total="this.article_data.total_count" />
            </Col>
          </Row>
        </Card>
      </Col>
      <Col span="12">
        <Card style="margin:20px;">
          <template #title>
            <Icon type="ios-stats"></Icon>
            公众号统计
          </template>
          <Row>
            <Col span="4">
              公众号
            </Col>
            <Col span="4">
              <NumberInfo sub-title="1小时发布" :total="this.mp_data.hour_count"  />
            </Col>
            <Col span="4">
              <NumberInfo sub-title="1天发布" :total="this.mp_data.day_count"  />
            </Col>
            <Col span="4">
              <NumberInfo sub-title="7天发布" :total="this.mp_data.week_count"  />
            </Col>
            <Col span="4">
              <NumberInfo sub-title="30天发布" :total="this.mp_data.month_count"  />
            </Col>
            <Col span="4">
              <NumberInfo sub-title="总数" :total="this.mp_data.total_count" />
            </Col>
          </Row>
        </Card>
      </Col>

      <Col span="12">
        <Card style="margin:20px;">
          <template #title>
            <Icon type="ios-stats"></Icon>
            索引任务统计
          </template>
          <Row>
            <Col span="4">
              索引任务
            </Col>
            <Col span="4">
              <NumberInfo sub-title="队列中" :total="this.task_data.index_queue_count"  />
            </Col>
            <Col span="4">
              <NumberInfo sub-title="处理中" :total="this.task_data.index_process_count"  />
            </Col>
            <Col span="4">
              <NumberInfo sub-title="1小时完成" :total="this.task_data.index_hour_done_count"  />
            </Col>
            <Col span="4">
              <NumberInfo sub-title="1天完成" :total="this.task_data.index_day_done_count"  />
            </Col>
            <Col span="4">
              <NumberInfo sub-title="总完成数" :total="this.task_data.index_total_done_count" />
            </Col>
          </Row>
        </Card>
      </Col>

      <Col span="12">
        <Card style="margin:20px;">
          <template #title>
            <Icon type="ios-stats"></Icon>
            正文任务统计
          </template>
          <Row>
            <Col span="4">
              正文任务
            </Col>
            <Col span="4">
              <NumberInfo sub-title="队列中" :total="this.task_data.content_queue_count"  />
            </Col>
            <Col span="4">
              <NumberInfo sub-title="处理中" :total="this.task_data.content_process_count"  />
            </Col>
            <Col span="4">
              <NumberInfo sub-title="1小时完成" :total="this.task_data.content_hour_done_count"  />
            </Col>
            <Col span="4">
              <NumberInfo sub-title="1天完成" :total="this.task_data.content_day_done_count"  />
            </Col>
            <Col span="4">
              <NumberInfo sub-title="总完成数" :total="this.task_data.content_total_done_count" />
            </Col>

          </Row>
        </Card>
      </Col>

      <Col span="12">
        <Card style="margin:20px;">
          <template #title>
            <Icon type="ios-stats"></Icon>
            公众账号统计
          </template>
          <Row>
            <Col span="4">
              公众账号
            </Col>
            <Col span="4">
              <NumberInfo sub-title="在线" :total="this.worker_data.mp_online_count"  />
            </Col>
            <Col span="4">
              <NumberInfo sub-title="离线" :total="this.worker_data.mp_offline_count"  />
            </Col>
            <Col span="4">
              <NumberInfo sub-title="登录" :total="this.worker_data.mp_login_count"  />
            </Col>
            <Col span="4">
              <NumberInfo sub-title="掉线" :total="this.worker_data.mp_other_count"  />
            </Col>
            <Col span="4">
              <NumberInfo sub-title="总数" :total="this.worker_data.mp_total_count" />
            </Col>
          </Row>
        </Card>
      </Col>

      <Col span="12">
        <Card style="margin:20px;">
          <template #title>
            <Icon type="ios-stats"></Icon>
            微信账号统计
          </template>
          <Row >
            <Col span="4">
              微信账号
            </Col>
            <Col span="4">
              <NumberInfo sub-title="在线" :total="this.worker_data.wx_online_count"  />
            </Col>
            <Col span="4">
              <NumberInfo sub-title="离线" :total="this.worker_data.wx_offline_count"  />
            </Col>
            <Col span="4">
              <NumberInfo sub-title="登录" :total="this.worker_data.wx_login_count"  />
            </Col>
            <Col span="4">
              <NumberInfo sub-title="掉线" :total="this.worker_data.wx_other_count"  />
            </Col>
            <Col span="4">
              <NumberInfo sub-title="总数" :total="this.worker_data.wx_total_count" />
            </Col>

          </Row>
        </Card>
      </Col>
    </Row>

    <!-- 加载状态 -->
    <Skeleton v-if="loading" loading :paragraph=25 />

    <!-- 错误提示 -->
    <div v-if="error" class="error">{{ error }}</div>

  </Content>
</template>

<style>
</style>
<script>
// @ is an alias to /src
import axios from 'axios';
import {Content} from "view-ui-plus";

const apiBase= process.env.VUE_APP_API_BASE

export default {
  name: 'HomeView',
  components: {Content},
  data() {
    return {
      loading: true,
      error: false,
      article_data: {},
      mp_data: {},
      task_data: {},
      worker_data: {},
    }
  },

  mounted() {
    console.log('mounted')
    this.fetchStatArticle()
    this.fetchStatMp()
    this.fetchStatTask()
    this.fetchStatWorker()
  },
  methods: {
    async fetchStatArticle() {
      try {
        this.loading = true
        const url = `${apiBase}/api/stat-article`
        const response = await axios.get(url)
        console.log(response.data)
        this.article_data = response.data.data
      } catch (err) {
        this.error = 'Failed to load data: ' + err.message
      } finally {
        this.loading = false
      }
    },
    async fetchStatMp() {
      try {
        this.loading = true
        const url = `${apiBase}/api/stat-mp`
        const response = await axios.get(url)
        console.log(response.data)
        this.mp_data = response.data.data
      } catch (err) {
        this.error = 'Failed to load data: ' + err.message
      } finally {
        this.loading = false
      }
    },
    async fetchStatTask() {
      try {
        this.loading = true
        const url = `${apiBase}/api/stat-task`
        const response = await axios.get(url)
        console.log(response.data)
        this.task_data = response.data.data
      } catch (err) {
        this.error = 'Failed to load data: ' + err.message
      } finally {
        this.loading = false
      }
    },
    async fetchStatWorker() {
      try {
        this.loading = true
        const url = `${apiBase}/api/stat-worker`
        const response = await axios.get(url)
        console.log(response.data)
        this.worker_data = response.data.data
      } catch (err) {
        this.error = 'Failed to load data: ' + err.message
      } finally {
        this.loading = false
      }
    },
  }
}
</script>
